module.exports = "data:image/svg+xml,export default __webpack_public_path__ + 'fonts/MarsCentra-Book.svg';"